module.exports = __webpack_public_path__ + "static/media/money_motivation_.c3ba2fff.svg";